const Footer = () => {
  return (
    <footer>
      <p>
        This website was created and programmed by{" "}
        <a href='https://github.com/sigristarisa'>Arisa Sigrist</a>, 2022
        Switzerland.
      </p>
    </footer>
  );
};

export default Footer;
